import alertsWidgetTemplate from './alertsWidget.html';
import './alertsWidget.scss';

export default angular
  .module('main.dashboardPanel.alertsWidget', [])

  .directive('alertsWidget', () => {
    return {
      restrict: 'E',
      template: alertsWidgetTemplate,
      scope: {},
      controller: ($scope,
                   utils,
                   $q,
                   DashboardDataProvider) => {
        $scope.noData = false;
        init();

        function init() {
          $scope.loading = true;

          DashboardDataProvider.getCallCenterAlertsLastWeek()
            .then((reportInfo) => {
              $scope.loading = false;
              if (!reportInfo || !reportInfo.dictionary || reportInfo.dictionary.length <= 0 || !reportInfo.executions || reportInfo.executions.length <= 0) {
                return;
              }

              let lastExecution = reportInfo.executions
                .slice()
                .filter(e => e.data?.length)
                .sort((a, b) => a.executionDateMs - b.executionDateMs) // latest last
                .pop();

              // Call Center Alerts (3 - daily, 2 - weekly, 1 - monthly)
              $scope.callCenterAlerts = lastExecution?.data?.find(d => d.id === 2)?.value;
              // Call Center Dispatch Events (6 - daily, 5 - weekly, 4 - monthly)
              $scope.callCenterDispatchEvents = lastExecution?.data?.find(d => d.id === 5)?.value;
            }, (err) => {
              utils.handleApiError(err);
              $scope.loading = false;
            });

        }
      }
    };
  })
  .name;
